import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageProjectResourceEditorComponent } from './page.project.resource.editor/page.project.resource.editor.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageHarnessesItemComponent } from './page.harnesses.item/page.harnesses.item.component';
import { PageEntityReviewsItemComponent } from './page.entity.reviews.item/page.entity.reviews.item.component';
import { PageReviewSurveyComponent } from './page.review.survey/page.review.survey.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageExpertsComponent } from './page.experts/page.experts.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageReviewTaskDatasetComponent } from './page.review.task.dataset/page.review.task.dataset.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageReviewResultItemComponent } from './page.review.result.item/page.review.result.item.component';
import { PageReviewProjectsItemComponent } from './page.review.projects.item/page.review.projects.item.component';
import { PageHumanReviewsComponent } from './page.human.reviews/page.human.reviews.component';
import { PageKgReviewsComponent } from './page.kg.reviews/page.kg.reviews.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageQaOperatorComponent } from './page.qa.operator/page.qa.operator.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageEntityDictionaryComponent } from './page.entity.dictionary/page.entity.dictionary.component';
import { PageReviewProjectsComponent } from './page.review.projects/page.review.projects.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageReviewTaskItemComponent } from './page.review.task.item/page.review.task.item.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageHarnessesComponent } from './page.harnesses/page.harnesses.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageEntityReviewsComponent } from './page.entity.reviews/page.entity.reviews.component';
import { PageSurveysComponent } from './page.surveys/page.surveys.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageEntityProjectsItemComponent } from './page.entity.projects.item/page.entity.projects.item.component';
import { PageEntityProjectsComponent } from './page.entity.projects/page.entity.projects.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageProjectResourceEditorComponent,
        PortalSeasonFormDropdownComponent,
        PageHarnessesItemComponent,
        PageEntityReviewsItemComponent,
        PageReviewSurveyComponent,
        LayoutSidebarComponent,
        PageExpertsComponent,
        PagePostsComponent,
        ComponentNavSidebarComponent,
        PortalSeasonPaginationComponent,
        PageAccessComponent,
        PageReviewTaskDatasetComponent,
        PortalSeasonTreeComponent,
        PageReviewResultItemComponent,
        PageReviewProjectsItemComponent,
        PageHumanReviewsComponent,
        PageKgReviewsComponent,
        PortalSeasonLoadingDefaultComponent,
        PageQaOperatorComponent,
        PageMypageComponent,
        PortalPostDetailComponent,
        PortalSeasonLoadingSeasonComponent,
        PageEntityDictionaryComponent,
        PageReviewProjectsComponent,
        PortalSeasonModalComponent,
        PageReviewTaskItemComponent,
        LayoutEmptyComponent,
        PageHarnessesComponent,
        PagePostsItemComponent,
        PageEntityReviewsComponent,
        PageSurveysComponent,
        PageMembersComponent,
        PageDashboardComponent,
        PortalPostListComponent,
        PageEntityProjectsItemComponent,
        PageEntityProjectsComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }